<div class="relative">
  <fin-content-image
    class="block image-height"
    [imageData$]="imageData() | finToObservable"
    [aspectRatio$]="imageAspectRatio() | finToObservable"
    [isLazyLoad]="false"
    [fetchPriority]="FetchPriorityEnum.high"
  />
  @if (teaserTitle()) {
    <div class="text-block absolute">
      <h2
        class="inline-block nordic-blue-900-text text-icon-primary white-bg surface-primary pr-xxsmall text-block-width font-headline-medium"
      >
        {{ teaserTitle() }}
      </h2>
    </div>
  }
</div>
@if (teaserText()) {
  <div class="pr-xsmall-x white-bg surface-primary nordic-blue-900-text text-icon-primary">
    <span class="ingress" [innerHTML]="teaserText() | finSafe: 'html'"></span>
  </div>
}
